import { render } from "./DbEntityEditPage.vue?vue&type=template&id=4dc9ac91"
import script from "./DbEntityEditPage.vue?vue&type=script&lang=js"
export * from "./DbEntityEditPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__